<template>
  <div>
    <div class="banner">
      <div class="banner-box d-flex" >
        <div class="title-box">
          <div class="text-box">
          </div>
        </div>
        <div class="content-box" style="width:50%; height:60vh; padding:20vh;">
          <div style="text-align:left">
            <p>
              多益考生必備字彙，依據ETS多益官方公布之測驗情境主題，由專業師資系統化整理歸納十大分類，涵蓋上千個多益必考單字片語句型，列出KK音標、詞性、例句、同義詞、衍生字，還有真人老師發音，好學好聽好記，帶你多益衝高分。
            </p>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
// import api from '../../store/api'
export default {
  name: 'Topic-Layout',
  components: {

  },
  data () {
    return {
      // categories: null
    }
  },
  mounted () {
    this.scrollTop()
  },
  methods : {
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/custom.scss";
  .banner {
    background-image: url('../../assets/image/pic/banner_bg_homelyenglish_top.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .title-box {
      width: 50%;
      .text-box {
        width: 50%;
        margin: auto;
        h4 {
          line-height: 200px;
          text-align: center;
          font-size: 150px;
          font-weight: 900;
          color: #fff;
          -webkit-text-stroke: 1.5px rgb(0, 0, 0);
        }
      }
    }
  }
  @media screen and (max-width: 420px) {
    .banner {
      width: 100vw;
      // height: 40vh;
      background-size: contain;
      background-image: url('../../assets/image/pic/banner_bg_toeic_word_top_SM_W.jpg');
    }
  }
  @media(max-width: 1080px){
    .banner {
      background-position: 0 0;
      .banner-box {
        display: none !important;
      }
    }
  }
</style>
